import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {TextEditorLarge} from './TextEditorLarge';
import {TextEditorSmall} from './TextEditorSmall';

export const TextEditor = () => (useIsLargishAndUp() ? <TextEditorLarge /> : <TextEditorSmall />);
